function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

   updateURL() {
  if (!this.currentVariant || this.dataset.updateUrl === "false") return;

  // Parse the current URL
  const url = new URL(window.location);

  // Update the 'variant' parameter
  url.searchParams.set('variant', this.currentVariant.id);

  // Update the browser's URL without reloading the page
  window.history.replaceState({}, '', url.toString());
}

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

$(".slider__").each(function (ind, el) {
  let liWidth = $(el).find("li")[0].getBoundingClientRect().width;
  $(".prev_btn").on("click", function () {});
});
$(".next_btn").on("click", function () {
  let slider = $(this).closest(".slider_wrap")[0].querySelector(".slider__");
  let scrollVal = $(slider).scrollLeft();
  let cardWidth = $(this)
    .closest(".slider_wrap")[0]
    .querySelector(".slider__ li")
    .getBoundingClientRect().width;
  $(slider).scrollLeft(scrollVal + cardWidth);
});
$(".prev_btn").on("click", function () {
  let slider = $(this).closest(".slider_wrap")[0].querySelector(".slider__");
  let scrollVal = $(slider).scrollLeft();
  let cardWidth = $(this)
    .closest(".slider_wrap")[0]
    .querySelector(".slider__ li")
    .getBoundingClientRect().width;
  $(slider).scrollLeft(scrollVal - cardWidth);
});

////// loading overlay
function display_overlay() {
  $(".loading_overlay")[0].style.display = "block";
}
function hide_overlay() {
  $(".loading_overlay")[0].style.display = "none";
}

// infinite scroll//

const priceCorrect = () => {
  console.log("price correct working");
  const linkURL = window.location.href;
  if (
    (linkURL.includes("ar-arab") ||
      linkURL.includes("en-arab") ||
      linkURL.includes(".ae")) &&
    linkURL.includes("/collections")
  ) {
    var gridItems = document.querySelectorAll(".grid__item");
    gridItems.forEach(function (gridItem) {
      var priceItem = gridItem.querySelector(".price-item.price-item--regular");
      if (priceItem) {
        priceItem.innerText = priceItem.innerText.replaceAll("Dhs.", "AED");
      }
    });
  } else if (linkURL.includes("en-sg") || linkURL.includes(".asia")) {
    var gridItemsSg = document.querySelectorAll(".grid__item");
    gridItemsSg.forEach(function (gridItem) {
      var priceItemSg = gridItem.querySelector(
        ".price-item.price-item--regular"
      );
      if (priceItemSg) {
        if (priceItemSg.innerText.includes('$')) {
          console.log ('$ included ', priceItemSg.innerText)
          priceItemSg.innerText = priceItemSg.innerText.replaceAll("$", "SGD ");
        } else {
          console.log ('$ not included ', priceItemSg.innerText)
        }
      }
    });
  }
};

const size_checker = () => {
  var size_div = document.querySelectorAll(".avl-sizes");
  size_div.forEach((item) => {
    if (item.querySelector(".light-text").textContent != "Size:") {
      item.querySelector(".light-text").textContent = "Size:";
      var sizeText = item.querySelector(".size-split").textContent;
      var sizeParts = sizeText.split("-");
      // console.log(sizeParts, sizeText)

      if (sizeParts[0] && sizeParts[1]) {
        // console.log("working double", sizeParts[0], sizeParts[1])
        var cleanSize1 = sizeParts[0]
          .replaceAll("'", "")
          .replaceAll('"', "")
          .replaceAll("x", "")
          .replaceAll("X", "")
          .replaceAll(" ", "")
          .trim();
        var cleanSize2 = sizeParts[1]
          .replaceAll("'", "")
          .replaceAll('"', "")
          .replaceAll("x", "")
          .replaceAll("X", "")
          .replaceAll(" ", "")
          .trim();

        var part_1 = ftcmarray.find((item) => item.ft == cleanSize1)?.cm;
        var part_2 = ftcmarray.find((item) => item.ft == cleanSize2)?.cm;

        if (part_1 && part_2) {
          item.querySelector(
            ".size-split"
          ).textContent = `${part_1} - ${part_2} cm`;
        } else {
          item.querySelector(".size-split").textContent = "Size not found";
        }
      } else {
        // console.log("working single", sizeParts[0])
        var cleanSize1 = sizeParts[0]
          .replaceAll("'", "")
          .replaceAll('"', "")
          .replaceAll("x", "")
          .replaceAll("X", "")
          .replaceAll(" ", "")
          .trim();
        var part_1 = ftcmarray.find((item) => item.ft == cleanSize1)?.cm;
        if (part_1) {
          item.querySelector(".size-split").textContent = `${part_1} cm`;
        } else {
          item.querySelector(".size-split").textContent = "Size not found";
        }
      }
    }
  });
};

// (Shopify.customLoadMoreButton = function () {
//   let e = document.querySelector(".load-more_wrap");
//   var t = new IntersectionObserver(
//     function (e) {
//       !0 === e[0].isIntersecting && sessionStorage.setItem("Load_More", "true"),
//         (function () {
//           if ("true" === sessionStorage.getItem("Load_More")) {
//             sessionStorage.setItem("Load_More", "false");
//             var e = $(".load-more-icon"),
//               t = parseInt($("[data-total-pages]").val()),
//               i = parseInt($("[data-current-page]").val());
//             i += 1;
//             var s = $("[data-next-url]")
//               .val().split("?")[0];
//             var m = `${s}?page=${i}`;
//               // .replace(/page=[0-9]+/, "page=" + i);
//             $("[data-current-page]").val(i),
//               $.ajax({
//                 url: m,
//                 type: "GET",
//                 dataType: "html",
//                 success: function (e) {
//                   console.log("loaded more products", i);
//                   $(".load-more__inner").append(
//                     $(e).find(".load-more__inner").html()
//                   );
//                 },
//                 complete: function () {
//                   i >= t && e.addClass("d-none");
//                   priceCorrect();
//                   if (
//                     window.location.href.includes(".ae") ||
//                     window.location.href.includes(".asia")
//                   ) {
//                     size_checker();
//                   }

//                   const gridItemProduct = document.querySelectorAll(".grid__item");
//                   const showReadyButton = document.getElementById("show_ready");
//                   const checkStoreURL = window.location.href;
//                   // fn to extract the size filter from the URL
//                   function extractSize(checkStoreURL) {
//                       const sizeURL = new URL(checkStoreURL);
//                       const sizeFilter = sizeURL.searchParams.get('filter.p.m.custom.size');
                      
//                       if (!sizeFilter) {
//                           return null;
//                       }
              
//                       const sizeFilterCleaned = sizeFilter.replace(/\'/g, '@').replace(/\"/g, '#');
//                       return sizeFilterCleaned;
//                   }
              
//                   // fn to match size filter with input data-value and check the value of the input
//                   function matchSizeAndFilterItems(sizeFilter) {
//                       gridItemProduct.forEach((item) => {
//                           const inventoryInputs = item.querySelectorAll(".inventory_input");
//                           let itemMatches = false;
              
//                           inventoryInputs.forEach((input) => {
//                               const dataValue = input.getAttribute('data-value');
//                               const regex = /\d+@(?:\d+#)?\s*x\s*\d+@(?:\d+#)?/;
//                               const sizeFromDataValue = dataValue.match(regex);
//                               const available = input.getAttribute('data-available');
              
//                               if (sizeFromDataValue) {
//                                   const size = sizeFromDataValue[0].trim();
//                                   if (size.includes(sizeFilter)) {
//                                       const url_ = window.location.href;
//                                       if(url_.includes('.com') && available.includes('India') && parseInt(input.value) > 0){
//                                         itemMatches = true;
//                                       }else if(url_.includes('.asia') && available.includes('Singapore') && parseInt(input.value) > 0){
//                                         itemMatches = true;
//                                       }else if(url_.includes('.ae') && available.includes('Dubai') && parseInt(input.value) > 0){
//                                         itemMatches = true;
//                                       }
//                                       // console.log(`Match found! Size: ${size} in data-value: ${dataValue} with value: ${input.value}`);
//                                   }
//                               }
//                           });
              
//                           // Display the item only if there's a match and value > 0
//                           if (itemMatches) {
//                               item.style.display = "block";
//                           } else {
//                               item.style.display = "none";
//                           }
//                       });
//                   }

//                   // fn to show all items
//                   function showAllItems() {
//                       gridItemProduct.forEach((item) => {
//                           item.style.display = "block";
//                       });
//                   }

//                   if (showReadyButton.checked) {
//                   const sizeFilterCleaned = extractSize(checkStoreURL);
//                       if (sizeFilterCleaned) {
//                           matchSizeAndFilterItems(sizeFilterCleaned);
//                       } else {
//                           console.log("No size filter found in URL");
//                       }
//                   } else {
//                       showAllItems();
//                   }
                  
//                   // const gridItemProduct = document.querySelectorAll(".grid__item");
//                   // const customNewFilter = document.querySelector(".custom_new-filter");
//                   // gridItemProduct.forEach((item) => {
//                   //   const inventory = item.querySelectorAll(".inventory_input");
//                   //   const inventoryData = item.querySelector(".inventory_data");
//                   //   let totalValue = 0;
//                   //   inventory.forEach((input) => {
//                   //     totalValue += parseInt(input.value) || 0;
//                   //   });
//                   //   if (inventoryData) {
//                   //     inventoryData.value = totalValue;
//                   //   }
//                   // });

//                   // const showReadyButton = document.getElementById("show_ready");
//                   //   if (showReadyButton.checked) {
//                   //     gridItemProduct.forEach((item) => {
//                   //       const inventoryData =
//                   //         item.querySelector(".inventory_data");
//                   //       if (inventoryData) {
//                   //         if (parseInt(inventoryData.value) > 0) {
//                   //           item.style.display = "block";
//                   //         } else {
//                   //           item.style.display = "none";
//                   //         }
//                   //       }
//                   //     });
//                   //   } else {
//                   //     gridItemProduct.forEach((item) => {
//                   //       item.style.display = "block";
//                   //     });
//                   //   }
//                 },
//               });
//           }
//         })();
//     },
//     {
//       threshold: [1],
//     }
//   );
//   null !== e && t.observe(e);
// }),
//   sessionStorage.setItem("Load_More", "false"),
//   Shopify.customLoadMoreButton();

////////////////Product card
if ($(".variant_select input")[0]) {
  $(".variant_select input").each(function (ind, el) {
    $(el).on("change", function () {
      let form = $(el).closest("form");
      let input = form[0].querySelector('input[name="id"]');
      input.value = el.dataset.id;
    });
  });
}

////////////Payment button
$(".payment_button").each(function (ind, el) {
  $(el).on("click", function (e) {
    e.preventDefault();
    let wrap = $(el).closest(".product__info-container");
    let input = wrap[0].querySelector('input[name="id"]');
    let quantity = wrap[0].querySelector(".quantity__input")
      ? wrap[0].querySelector(".quantity__input").value
      : 1;
    let data = {
      items: [
        {
          id: input.value,
          quantity: quantity,
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      window.location.href = "/checkout";
    });
  });
});
if ($(".add-to-wishlist")[0]) {
  $(".add-to-wishlist").each(function (ind, el) {
    let input_ = $(el)
      .closest(".wishlist_button")[0]
      .querySelector('input[type="hidden"]');
    let data = input_.dataset.id;
    let wishProduct = JSON.parse(localStorage.getItem("wishlist"));
    if (wishProduct.indexOf(data) == -1) {
      el.classList.remove("added");
    } else {
      el.classList.add("added");
    }
  });
}
if (!localStorage.getItem("wishlist")) {
  localStorage.setItem("wishlist", "[]");
}
$(".add-to-wishlist").on("click", function () {
  let data;
  let input_ = $(this)
    .closest(".wishlist_button")[0]
    .querySelector('input[type="hidden"]');
  data = input_.dataset.id;
  let wishProduct = JSON.parse(localStorage.getItem("wishlist"));
  if (wishProduct.indexOf(data) == -1) {
    wishProduct.push(data);
    $(".add-to-wishlist")[0].classList.add("added");
  } else {
    wishProduct.splice(wishProduct.indexOf(data), 1);
    $(".add-to-wishlist")[0].classList.remove("added");
  }
  localStorage.setItem("wishlist", JSON.stringify(wishProduct));
  updateWishCount();
});
$(document).on("click", function (e) {
  if (
    $(e.target)[0].classList.contains("remWish") ||
    $(e.target).closest(".remWish")[0]
  ) {
    e.preventDefault();
    let el = e.target;
    let data = $(el)
      .closest(".product_list")[0]
      .querySelector('input[name="id"]').value;
    let wishProduct = JSON.parse(localStorage.getItem("wishlist"));
    wishProduct.splice(wishProduct.indexOf(data), 1);
    localStorage.setItem("wishlist", JSON.stringify(wishProduct));
    updateWish();
    updateWishCount();
  }
});
function updateWishCount() {
  let wishProduct = JSON.parse(localStorage.getItem("wishlist"));
  if (!wishProduct) return;
  $(".wish_count")[0].textContent = wishProduct.length;
}
if ($(".wishlist_btn")[0]) {
  updateWishCount();
}
const displayQuick = () => {
  if (
    $(".quick_view_wrap")[0].style.display == "none" ||
    $(".quick_view_wrap")[0].style.display == ""
  ) {
    $(".quick_view_wrap")[0].style.display = "block";
    $(".quick_view_overlay")[0].classList.add("dis");
    setTimeout(function () {
      $(".quick_view_wrap")[0].style.opacity = "1";
      $(".quick_view_overlay")[0].style.opacity = "1";
    }, 0);
  } else {
    $(".quick_view_wrap")[0].style.opacity = "0";
    $(".quick_view_overlay")[0].opacity = "0";
    setTimeout(function () {
      $(".quick_view_wrap")[0].style.display = "none";
      $(".quick_view_overlay")[0].classList.remove("dis");
    }, 0);
  }
};
$(".quick_view_overlay").on("click", function () {
  displayQuick();
});
$(document).on("click", function (e) {
  if (
    e.target.classList.contains("ajaxCart") &&
    $(e.target).closest(".quick_view_wrap")[0]
  ) {
    displayQuick();
  }
});
$(document).on("click", function (e) {
  if (
    e.target.classList.contains("quick_view") ||
    $(e.target).closest("quick_view")[0]
  ) {
    let el = e.target.classList.contains("quick_view")
      ? e.target
      : $(e.target).closest("quick_view")[0];
    let productTitle = el.dataset.title.toLowerCase().replaceAll("--", "-");
    let fetchUrl = /products/ + productTitle + "?view=quick-view";
    fetch(fetchUrl)
      .then((response) => response.text())
      .then((data) => {
        display_overlay();
        let parser = new DOMParser();
        let html_ = parser.parseFromString(data, "text/html");
        let prd = html_.querySelector(".quickView_box");
        $(".quick_view_wrap")[0].innerHTML = "";
        $(".quick_view_wrap")[0].appendChild(prd);
        hide_overlay();
        displayQuick();
      })
      .catch((err) => err);
  }
});
const varAvailability = (el) => {
  let variantData = JSON.parse(
    el.querySelector('script[type="application/json"]').innerHTML
  );
  let selectedVarId = el.querySelector('input[name="id"]').value;
  let selectedVar = variantData.find((el) => el.id == selectedVarId);
  let radioInputs = el.querySelectorAll('input[type="radio"]');
  let addBtn = el.querySelector(".ajaxCart");
  for (let radio of radioInputs) {
    if (selectedVar.options.indexOf(radio.dataset.val) !== -1) {
      radio.checked = true;
    }
  }
  if (selectedVar.available) {
    addBtn.disabled = false;
  } else {
    addBtn.disabled = true;
  }
};
const updateCardPrice = (el, price) => {
  let regularPrice;
};
var moneyFormatter = Intl.NumberFormat("en-US", {
  style: "currency",
  currency: Shopify.currency.active,
});

$(document).on("click", function (e) {
  if (
    e.target.classList.contains("product__form") ||
    $(e.target).closest(".product__form")[0]
  ) {
    let el = e.target.classList.contains("product__form")
      ? e.target
      : $(e.target).closest(".product__form")[0];
    let variantsData = JSON.parse(
      $(el).find('script[type="application/json"]')[0].innerHTML
    );
    let inputRadios = $(el).find(".option_values");
    let activeVariant = {};
    let selectedData = [];
    let activeData;
    let addBtn = $(el).find(".ajaxCart");
    let comparePriceField = $(el)
      .closest(".product_info")[0]
      .querySelector(".compare_price");
    let priceField = $(el).closest(".product_info")[0].querySelector(".price");
    $(inputRadios).each(function (ind, el) {
      let inputs = el.querySelectorAll('input[type="radio"]');
      $(inputs).each(function (ind_, el_) {
        if (el_.checked) {
          activeVariant[el.dataset.value] = el_.dataset.val;
        }
      });
    });
    for (let variant in activeVariant) {
      selectedData.push(activeVariant[variant]);
    }
    for (let data of variantsData) {
      if (
        data.options.length == selectedData.length &&
        data.options.every((el) => selectedData.indexOf(el) !== -1)
      ) {
        activeData = data;
      }
    }
    activeData.available
      ? addBtn[0].removeAttribute("disabled")
      : addBtn[0].setAttribute("disabled", true);
    if (comparePriceField) {
      comparePriceField.textContent = moneyFormatter.format(
        activeData.compare_at_price / 100
      );
    }
    if (priceField) {
      priceField.textContent = moneyFormatter.format(activeData.price / 100);
    }
  }
});
